import { checkOperation } from "./checkOperation";
import type { Operation } from "./types";

export function CheckOperation({
	operation,
	operations,
	children,
	showOperation,
	disabled = false,
	invert,
}: React.PropsWithChildren<{
	operation: string | string[];
	operations: Operation[];
	disabled?: boolean;
	showOperation?: boolean;
	invert?: boolean;
}>) {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (!operations) {
		return <>Ops are null {operation}</>;
	}

	let check = checkOperation({
		operation,
		operations,
		disabled,
	});

	if (invert) {
		check = !check;
	}

	return check ? (
		<>
			{children}
			{showOperation && operation}
		</>
	) : !(
			showOperation || import.meta.env.VITE_DEBUG_CHECKS === "true"
	  ) ? null : (
		<>{operation}</>
	);
}
